import React, { useContext } from 'react';
import {Box, Grid,Stack, TableContainer, Typography, Paper, Table, TableRow, TableCell, TableBody, Button, useMediaQuery } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { ApptContext } from '../../contexts/appointment.context';
import withHooks from '../../../../utils/withHooks';
import { useTheme } from '@emotion/react';
import { PracticeSesContext } from '../../../practice-session/contexts/practice-session.context';
import { useLocation } from 'react-router-dom';
import appointmentService from '../../../../services/http/appointments/appointment.service';
import PatientInvoiceLog from './PatientInvoiceLog';


interface PaymentDetailsData {
  apptId: string;
  phone: string;
  fees: string;
  referenceId: string;
  status: string;
  paymentMode: string;
  message: string;
  paidAt: string;
}

class OnlinePaymentDetails extends React.Component<any, any> {
  constructor(props:any){
    super(props);
    this.state={
      paymentDetails: {},
      loading: true,
    }
  }

  componentDidMount() {
    this.fetchPaymentDetail();
  }

  fetchPaymentDetail = async () => {
    const apptId = new URLSearchParams(this.props.location.search).get('apptId');

    const paymentDetails = apptId ? await appointmentService.getPaymentDetail(apptId) : null;

    this.setState({ paymentDetails: paymentDetails || {}, loading: false });
  }
  capitalizeFirstLetter = (str: string) => {
    if(str==="utr")
      {
        return str.toUpperCase();
      }
      return str.charAt(0).toUpperCase() + str.slice(1);
    
  };

  handleWhatsAppClick = () => {
    const { phone } = this.state.paymentDetails;
    if (!phone) return;
    const number=phone.slice(1)
    const whatsappUrl = `https://wa.me/+91${number}`;
    window.open(whatsappUrl, '_blank');
  }

  render() {
    const { paymentDetails, loading } = this.state;
    const {isMd}=this.props;
    const paymentDetailKeys = Object.keys(paymentDetails);
    const apptId = new URLSearchParams(this.props.location.search).get('apptId');
    
    return (
      <div>
        <Button startIcon={<ArrowBackIosIcon />} onClick={() => window.history.back()}>Back</Button>
        <Stack sx={{ marginTop: '20px', padding: '20px' }}>
          <Typography variant="h5" style={{ marginBottom: '15px' }}>
            Payment Details
          </Typography>
          <Paper elevation={2} style={{ padding: '20px' }}>
          {loading ? (
            <Typography>Loading...</Typography>
          ) : paymentDetailKeys.length === 0 ? (
            <Typography>No payment details found for this appointment.</Typography>
          ) : (
          <TableContainer>
  <Table sx={{ minWidth: 650 }} aria-label="payment details table">
    <TableBody>
      {paymentDetailKeys.map((key, index) => (
        <TableRow key={key} sx={{ bgcolor: index % 2 === 0 ? 'grey.200' : 'white' }}>
          <TableCell>
            {isMd ? (
              <Grid container spacing={2}>
                <Grid item xs={3}>
                  <strong>{this.capitalizeFirstLetter(key)}</strong>
                </Grid>
                <Grid item xs={9}>
                  {paymentDetails[key as keyof PaymentDetailsData]}
                </Grid>
              </Grid>
            ) : (
              <>
                <Grid container spacing={16}>
                <Grid item xs={3}>
                    <strong>{this.capitalizeFirstLetter(key)}</strong>
                </Grid>
                <Grid item xs={9}>
                    <Box display="block" justifyContent="center">
                    {paymentDetails[key as keyof PaymentDetailsData]}
                    </Box>
                </Grid>
                </Grid>
              </>
            )}
          </TableCell>
        </TableRow>
      ))}
      <TableRow sx={isMd ? { bgcolor: 'grey.200' } : { bgcolor: 'grey.200' }}>
        <TableCell>
          <Grid container spacing={2}>
            <Grid item xs={3}>
              <strong>WhatsApp</strong>
            </Grid>
            <Grid item xs={9}>
              <Button onClick={this.handleWhatsAppClick}>
                <WhatsAppIcon style={{ color: 'green' }} />
              </Button>
            </Grid>
          </Grid>
        </TableCell>
      </TableRow>
    </TableBody>
  </Table>
</TableContainer>
          )}

</Paper>



        </Stack>
        <PatientInvoiceLog apptId={apptId} />
      </div>
    );
  }
}

export default withHooks(OnlinePaymentDetails, [
    ['theme', useTheme],
    ['isMd', (() => useMediaQuery((theme: any) => theme.breakpoints.down('md')))],
    ['apptContext', useContext, [ApptContext]],
    ['practiceSesContext', useContext, [PracticeSesContext]],
    ['location', useLocation]
])
